import { getStorefront } from './store.js';
import { isInitialized } from '../core/config.js';
import {
  searchMergedStorefrontCatalog,
  searchMergedStorefrontCatalogItems,
  type StorefrontCatalogSearchItem,
} from '../utils/storefront-search.js';
import type { SDKResponse, Product } from '../types/index.js';

export interface SearchOptions {
  hideOutOfStock?: boolean;
  maxResults?: number;
}

export type { StorefrontCatalogSearchItem };

export async function searchCatalogItems(
  query: string,
  options?: SearchOptions,
): Promise<SDKResponse<StorefrontCatalogSearchItem[]>> {
  if (!isInitialized()) {
    return { success: false, message: 'SDK not initialized' };
  }

  const trimmed = query.trim();
  if (!trimmed) {
    return { success: true, data: [] };
  }

  const storefront = await getStorefront();
  if (!storefront.success || !storefront.data) {
    return {
      success: false,
      message: storefront.message ?? 'Failed to fetch storefront catalog',
    };
  }

  const results = searchMergedStorefrontCatalogItems(
    storefront.data.products ?? [],
    storefront.data.groups ?? [],
    trimmed,
    {
      hideOutOfStock: options?.hideOutOfStock,
      maxResults: options?.maxResults,
    },
  );

  return { success: true, data: results };
}

export async function searchProducts(
  query: string,
  options?: SearchOptions,
): Promise<SDKResponse<Product[]>> {
  if (!isInitialized()) {
    return { success: false, message: 'SDK not initialized' };
  }

  const trimmed = query.trim();
  if (!trimmed) {
    return { success: true, data: [] };
  }

  const storefront = await getStorefront();
  if (!storefront.success || !storefront.data) {
    return {
      success: false,
      message: storefront.message ?? 'Failed to fetch storefront catalog',
    };
  }

  const results = searchMergedStorefrontCatalog(
    storefront.data.products ?? [],
    storefront.data.groups ?? [],
    trimmed,
    {
      hideOutOfStock: options?.hideOutOfStock,
      maxResults: options?.maxResults,
    },
  );

  return { success: true, data: results };
}
